const EDIT_APP_POPUP_DRAFT_PREFIX = 'admin:appPopupDraft:edit:'
export const NEW_APP_POPUP_DRAFT_KEY = 'admin:appPopupDraft:new'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    try {
        return window.sessionStorage
    } catch (_error) {
        // 브라우저 정책으로 storage 접근이 막혀도 팝업 작성 화면은 계속 동작한다.
        return null
    }
}

const normalizeTextValue = (value, fallbackValue = '') => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    return String(value)
}

const normalizeNumberValue = (value, fallbackValue) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// App 랜덤 팝업 폼은 이미지 파일을 제외한 기본 필드와 상품 선택 검색 상태만 sessionStorage에 남긴다.
export const createAppPopupDraftPayload = ({
    params = {},
    pickerPage = 1,
    pickerSearchText = '',
} = {}) => {
    return {
        params: {
            deviceType: normalizeTextValue(params.deviceType, 'all'),
            type: normalizeNumberValue(params.type, 1),
            status: normalizeNumberValue(params.status, 1),
            landingUrl: normalizeTextValue(params.landingUrl),
            meetId: normalizeNumberValue(params.meetId, null),
        },
        pickerPage: normalizeNumberValue(pickerPage, 1),
        pickerSearchText: normalizeTextValue(pickerSearchText),
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 팝업 작성 흐름을 이어간다.
export const applyAppPopupDraft = ({
    baseParams = {},
    basePickerPage = 1,
    basePickerSearchText = '',
    draft,
} = {}) => {
    const normalizedBaseDraft = createAppPopupDraftPayload({
        params: baseParams,
        pickerPage: basePickerPage,
        pickerSearchText: basePickerSearchText,
    })

    if (!draft) {
        return {
            params: {
                ...baseParams,
                ...normalizedBaseDraft.params,
            },
            pickerPage: normalizedBaseDraft.pickerPage,
            pickerSearchText: normalizedBaseDraft.pickerSearchText,
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            deviceType: draftParams.deviceType === undefined
                ? normalizedBaseDraft.params.deviceType
                : normalizeTextValue(draftParams.deviceType, normalizedBaseDraft.params.deviceType),
            type: draftParams.type === undefined
                ? normalizedBaseDraft.params.type
                : normalizeNumberValue(draftParams.type, normalizedBaseDraft.params.type),
            status: draftParams.status === undefined
                ? normalizedBaseDraft.params.status
                : normalizeNumberValue(draftParams.status, normalizedBaseDraft.params.status),
            landingUrl: draftParams.landingUrl === undefined
                ? normalizedBaseDraft.params.landingUrl
                : normalizeTextValue(draftParams.landingUrl),
            meetId: draftParams.meetId === undefined
                ? normalizedBaseDraft.params.meetId
                : normalizeNumberValue(draftParams.meetId, normalizedBaseDraft.params.meetId),
        },
        pickerPage: draft.pickerPage === undefined
            ? normalizedBaseDraft.pickerPage
            : normalizeNumberValue(draft.pickerPage, normalizedBaseDraft.pickerPage),
        pickerSearchText: draft.pickerSearchText === undefined
            ? normalizedBaseDraft.pickerSearchText
            : normalizeTextValue(draft.pickerSearchText),
    }
}

export const createEditAppPopupDraftKey = (popupId) => `${EDIT_APP_POPUP_DRAFT_PREFIX}${popupId}`

export const readAppPopupDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppPopupDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppPopupDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
